import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { FormField } from '../../../../components/form/FormField';
import { fieldValidators } from '../../../../helpers/fieldValidators';
import { Loader } from '../../../../components/Loader';

let ControlPostForm = props => {
  const { error, handleSubmit, submitting, currentItem } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="title"
        type="text"
        label="Название"
        validate={[fieldValidators.required]}
        component={FormField}
      />
      <Field
        name="equipment_seria_number"
        type="text"
        label="Серийный номер"
        component={FormField}
      />

      {error && <strong>{error}</strong>}
      <div>
        {submitting && <Loader />}
        <button type="submit" className="btn" disabled={submitting}>
          {currentItem ? 'Редактировать' : 'Создать'}
        </button>
      </div>
    </form>
  );
};

ControlPostForm = reduxForm({
  form: 'control-ost-form', // a unique identifier for this form
  enableReinitialize: true
})(ControlPostForm);

ControlPostForm = connect(state => ({
  initialValues: {
    id: state.controlPosts.currentItem ? state.controlPosts.currentItem.id : '',
    title: state.controlPosts.currentItem ? state.controlPosts.currentItem.title : '',
    equipment_seria_number: state.controlPosts.currentItem ? state.controlPosts.currentItem.equipment_seria_number : ''
  }
}))(ControlPostForm);

export default ControlPostForm;
